import "./ProgressBar.scss";

const ProgressBar = ({ step }) => {
  return (
    <div className="progress__bar">
      <span className="active">1</span>
      <span className={step >= 6 ? "active" : ""}>2</span>
      <span className={step >= 7 ? "active" : ""}>3</span>
      <span className={step >= 8 ? "active" : ""}>4</span>
      <span className={step >= 9 ? "active" : ""}>5</span>
    </div>
  );
};
export default ProgressBar;
